import React, { useEffect, useState } from 'react'
import { Route, Switch } from 'react-router-dom'
import reportApi from '_api/report'
import userApi from '_api/user'
import Header from '_components/Header'
// import Footer from '_components/Footer'
import NewFooter from '_components/NewFooter'
import useData from '_hooks/useData'
import { setUserInfo, getUserToken } from '_utils/localData'

import EventList from './Event/EventList'
import EventPage from './Event'
import GroupPage from './Group'
import UserPage from './UserV2'

const MainPage = () => {
  useData()
  const token = getUserToken()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!token) {
      setLoading(false)
      return
    }

    userApi
      .getUser()
      .then(({ msgResp }) => {
        setUserInfo(msgResp)
        setLoading(false)
      })
      .catch(({ msgResp, msgCode, message }) => {
        setLoading(false)
        if (msgCode) {
          reportApi.report({ message: `[Main]${msgCode} - ${msgResp}` })
        } else {
          reportApi.report({ message: `[Main - client]${message}` })
        }
      })
    return () => {
      setLoading({})
    }
  }, [])

  if (loading) {
    return <div>Loading...</div>
  }

  return (
    <div className='main-mobile-layout'>
      <Header />
      <section className='section-content section-content--top mains-screen' id='checkHeight'>
        <Switch>
          <Route
            path='/user'
            render={() => (
              <div className='user-v2-private-container'>
                <UserPage />
              </div>
            )}
          />
          <Route
            render={() => (
              <div className='container'>
                <Switch>
                  <Route path='/group' component={GroupPage} />
                  <Route path='/event' component={EventPage} />
                  <Route path='/home' exact component={EventList} />
                </Switch>
              </div>
            )}
          />
        </Switch>
      </section>
      <NewFooter />
    </div>
  )
}

export default MainPage
